import React, { useState, useEffect } from "react";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

function Menu() {
  const [userData, setUserData] = useState(null);
  const [username, setUsername] = useState("");
  const [expandedMenus, setExpandedMenus] = useState({});

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      setUserData(user);
      if (user) {
        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setUsername(docSnap.data().username);
        }
      }
    });

    return () => unsubscribe();
  }, []);

  const toggleMenu = (index) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const menuItems = [
    { title: "Home", icon: "fa fa-home", link: "/home" },
    {
      title: "Reservations",
      icon: "fa fa-users",
      submenu: [
        { title: "Reserve Room", link: "/reserve-room" },
        { title: "Live Bookings", link: "/live-bookings" },
        { title: "Checkout History", link: "/checkout-history" },
        { title: "Planwise Bookings", link: "/planwise-bookings" },
      ],
    },
     {
      title: "Future Bookings",
      icon: "fa fa-search-plus",
      submenu: [
        { title: "Future Paid Bookings", link: "/future-paid-bookings" },
        { title: "View Future Bookings", link: "/view-future-bookings" },
      ],
    },
    { title: "Damage Notes", icon: "fas fa-house-damage", link: "/damage-notes" },
    { title: "Approval Requests", icon: "fa fa-spinner", link: "/approval-requests" },
    { title: "Pending Payments", icon: "fa fa-money", link: "/pending-payments" },
   
    {
      title: "OTA Mgmt",
      icon: "fa fa-globe",
      submenu: [
        { title: "Website Rooms", link: "/website-rooms" },
        { title: "Website Gallery", link: "/website-gallery" },
      ],
    },
    {
      title: "Master",
      icon: "fa fa-table",
      submenu: [
        { title: "Company Details", link: "/company-details" },
        { title: "Booking Types", link: "/booking-types" },
        { title: "Owner Credit", link: "/owner-credit" },
        { title: "Customers", link: "/customers" },
      ],
    },
    {
      title: "Report",
      icon: "fa fa-file",
      submenu: [
        { title: "Daily Report", link: "/daily-report" },
        { title: "Checkout Alert", link: "/checkout-alert" },
        { title: "Back Date Report", link: "/back-date-report" },
        { title: "Mobile No Wise Booking", link: "/mobileno-wise-bookings" },
      ],
    },
  ];

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      {/* Brand Logo */}
      <a href="#0" className="brand-link">
        <img
          src={window.location.origin + "/user.jpg"}
          alt="User"
          className="brand-image img-circle elevation-3"
          style={{ opacity: ".8" }}
        />
        <span className="brand-text font-weight-light">{username}</span>
      </a>

      <div className="sidebar">
        <nav className="mt-2">
          <ul
            className="nav nav-pills nav-sidebar flex-column"
            role="menu"
            data-accordion="false"
          >
            {menuItems.map((item, index) => {
              const hasSubmenu = !!item.submenu;
              const isOpen = expandedMenus[index];
              return (
                <li
                  key={index}
                  className={`nav-item ${hasSubmenu && isOpen ? "menu-open" : ""}`}
                >
                  <a
                    href={item.link || "#0"}
                    className={`nav-link ${hasSubmenu && isOpen ? "active" : ""}`}
                    onClick={(e) => {
                      if (hasSubmenu) {
                        e.preventDefault();
                        toggleMenu(index);
                      }
                    }}
                  >
                    <i className={`nav-icon ${item.icon}`} />
                    <p>
                      {item.title}
                      {hasSubmenu && (
                        <i
                          className={`right fa fa-angle-${isOpen ? "down" : "left"}`}
                        />
                      )}
                    </p>
                  </a>

                  {hasSubmenu && (
                    <ul className="nav nav-treeview">
                      {item.submenu.map((sub, subIndex) => (
                        <li key={subIndex} className="nav-item">
                          <a href={sub.link} className="nav-link">
                            <i className="far fa-circle nav-icon" />
                            <p>{sub.title}</p>
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </aside>
  );
}

export default Menu;
